const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const SCOPED_PATH_PREFIXES = [
  "/upload",
  "/sources",
  "/validation",
  "/admin/knowledge-curation",
  "/admin/knowledge-findings",
  "/admin/knowledge-items",
  "/admin/knowledge-usage",
  "/admin/sensitive-data",
  "/story-preparations",
] as const;

export function selectedRepositoryId(search?: string): string | null {
  const effectiveSearch = search ?? (typeof window === "undefined" ? "" : window.location.search);
  const value = new URLSearchParams(effectiveSearch).get("repository");
  return value !== null && UUID_PATTERN.test(value) ? value : null;
}

export function isRepositoryScopedApiPath(path: string): boolean {
  return SCOPED_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function applyRepositoryScopeToUrl(url: URL): URL {
  if (!isRepositoryScopedApiPath(url.pathname) || url.searchParams.has("repository")) return url;
  const repositoryId = selectedRepositoryId();
  if (repositoryId !== null) url.searchParams.set("repository", repositoryId);
  return url;
}
